import { Fragment } from "react";

const render = (content, context) =>
  typeof content === "function" ? content(context) : content;

const OrderedWorkspace = ({
  className = "",
  blocks,
  panel = null,
  context = {},
}) => (
  <div className={["ordered-workspace", className].filter(Boolean).join(" ")}>
    {blocks.map((block) => (
      <section
        key={block.id}
        className={["ordered-workspace__block", block.className]
          .filter(Boolean)
          .join(" ")}
        data-block={block.id}
        aria-label={block.label}
      >
        {render(block.content, context)}
      </section>
    ))}
    <Fragment>{render(panel, context)}</Fragment>
  </div>
);

export default OrderedWorkspace;
